module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v(_vm._s(_vm.apelido))]), _vm._v(" "), (_vm.proprietario || _vm.tipo || _vm.savoyNetItems.length > 0) ? _c('div', {
    staticClass: "detalhes-toolbar-extension",
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [(_vm.tipo) ? _c('span', {
    staticStyle: {
      "margin": "0 18px"
    }
  }, [_c('span', {
    staticClass: "caption secondary--text",
    staticStyle: {
      "font-weight": "500 !important"
    }
  }, [_vm._v("Tipo")]), _vm._v(" " + _vm._s(_vm.tipo))]) : _vm._e(), _vm._v(" "), (_vm.proprietario) ? _c('span', [_c('span', {
    staticClass: "caption secondary--text",
    staticStyle: {
      "font-weight": "500 !important"
    }
  }, [_vm._v("Proprietário")]), _vm._v(" " + _vm._s(_vm.proprietario))]) : _vm._e(), _vm._v(" "), (_vm.savoyNetItems.length === 1) ? _c('span', {
    staticStyle: {
      "margin-left": "18px"
    }
  }, [_c('span', {
    staticClass: "caption secondary--text",
    staticStyle: {
      "font-weight": "500 !important"
    }
  }, [_vm._v("SavoyNet")]), _vm._v(" "), _c('a', {
    staticClass: "white--text",
    attrs: {
      "href": _vm.savoyNetItems[0].url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.savoyNetItems[0].numero) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.savoyNetItems.length > 1) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 savoynet-ativador",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "caption secondary--text",
    staticStyle: {
      "font-weight": "500 !important"
    }
  }, [_vm._v("SavoyNet")]), _vm._v(" "), _c('span', {
    staticClass: "white--text",
    staticStyle: {
      "margin-left": "4px"
    }
  }, [_vm._v("(" + _vm._s(_vm.savoyNetItems.length) + ")")])]), _vm._v(" "), _c('v-card', [_c('v-list', _vm._l((_vm.savoyNetItems), function(item) {
    return _c('v-list-tile', {
      key: item.numero,
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.numero))])], 1)
  }))], 1)], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86009418"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Headers/HeadersDetalhesResumo.vue
// module id = 1033
// module chunks = 1